import styled, { keyframes, css } from 'styled-components';

const animation = keyframes`
  0% { left: -100px; }
  100% { left: 100%; }
`;

const backgroundAnimate = (durationSeconds = 0.8) => css`
  background: #E9E9E9;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  &:before {
    content: '';
    width:300px;
    animation: ${animation} ${durationSeconds}s linear infinite;
    position:absolute;
    background: linear-gradient(to right, transparent 0%, rgba(255,255,255,0.3) 30%, rgba(0,0,0,0.02) 60%, transparent 100%);
    left:0;
    top:0;
    bottom:0;
  };
`;

const hoc = (durationSeconds: number = 0.8) => (
  <P extends object>(Component: React.ComponentType<P>) =>
    (styled(Component)`${backgroundAnimate(durationSeconds)}`)
);

export const withShimmer = hoc;
